import { render, staticRenderFns } from "./SceneControls.vue?vue&type=template&id=ea4c0c34&scoped=true&"
import script from "./SceneControls.vue?vue&type=script&lang=ts&"
export * from "./SceneControls.vue?vue&type=script&lang=ts&"
import style0 from "./SceneControls.vue?vue&type=style&index=0&id=ea4c0c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4c0c34",
  null
  
)

export default component.exports